import { createSelector } from '@reduxjs/toolkit';

export const selectUser = ({ user }) => user;

export const selectAgencyId = createSelector(
  selectUser,
  ({ agencyId }) => agencyId
);
